import Flex from '@Components/Bases/Flex';
import FormTextAreaAutoSize from '@Components/Form/FormTextAreaAutosize';
import { disabledTextAreaInputStyles } from '@Components/Form/styles';
import { InputLabel } from '@mui/material';
import { IGreenhouseFormValues } from '@Router/EsgGreenhouse/Containers/EsgGreenhouseFormProvider/types';
import { Control, useFormContext, useWatch } from 'react-hook-form';

type SubcommitteeChartersThProps = {
  control: Control<IGreenhouseFormValues, unknown>;
};

const SubcommitteeChartersTh = ({ control }: SubcommitteeChartersThProps) => {
  const completedSection = useWatch({
    name: 'climateChangeStructure.completedSection',
    control,
  });

  const { watch } = useFormContext();
  const subcommitteeType = watch('subcommitteeType');
  const isSubcommitteeTypeEmpty = subcommitteeType === '';

  const { isCompletedTh = false } = completedSection ?? {};

  return (
    <Flex flexDirection="column">
      <Flex>
        <InputLabel
          sx={{
            textAlign: 'end',
            paddingLeft: 6,
            marginRight: 2,
            width: 1,
            minWidth: 200,
            lineHeight: '1.5',
            whiteSpace: 'pre-wrap',
          }}
        >
          ลิงก์กฎบัตร{'\n'}ตามชื่อ คณะกรรมการชุดย่อย{'\n'}ที่ระบุข้างต้น (ไทย)
          (ถ้ามี)
        </InputLabel>
        <Flex gap={1} minWidth={600}>
          <FormTextAreaAutoSize
            label="ลิงก์"
            name="charterUrlTh"
            inputProps={{
              placeholder:
                'กรุณาระบุลิงก์กฎบัตรตามชื่อคณะกรรมการชุดย่อยที่ระบุข้างต้น',
              minRows: 3,
              readOnly: isCompletedTh,
              tabIndex: isCompletedTh ? -1 : undefined,
            }}
            sx={
              isCompletedTh || isSubcommitteeTypeEmpty
                ? disabledTextAreaInputStyles
                : {}
            }
            flex={1}
            minWidth={200}
          />
          <FormTextAreaAutoSize
            label="เลขหน้าของลิงก์"
            name="charterPageTh"
            inputProps={{
              placeholder: 'กรุณาระบุเลขหน้า',
              minRows: 3,
              readOnly: isCompletedTh,
              tabIndex: isCompletedTh ? -1 : undefined,
            }}
            sx={
              isCompletedTh || isSubcommitteeTypeEmpty
                ? disabledTextAreaInputStyles
                : {}
            }
            flex={1}
            minWidth={200}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default SubcommitteeChartersTh;
